//Global Helper for managing local storage

const $         = require('jQuery');
const _model    = require( './_model.js' );
const sjcl      = require( './__sjcl.js' );

module.exports  = (function () {

    var localStorage = window.localStorage;

    var ls = {};
    ls.hasData = function (key) {
        return !!localStorage[key] && !!localStorage[key].length;
    };
    ls.get = function (key) {
        if (!this.hasData(key)) {
            return false;
        }
        var data = localStorage[key];
        try {
            return JSON.parse(data);
        }
        catch (e) {
            return data;
        }
    };
    ls.set = function (key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (e) { localStorage.setItem(key, value); }
    };

    ls.extend = function (key, value, inverse = false) {
        if (this.hasData(key)) {
            var _value = this.get(key);
            if( inverse ){
                $.extend(true, JSON.parse(JSON.stringify(value) ),  _value );
            }else{
                $.extend(true, _value, JSON.parse(JSON.stringify(value)));
            }

            this.set(key, _value);
        }
        else {
            this.set(key, value);
        }
    };
    ls.remove = function (key) {
        localStorage.removeItem(key);
    };

    //this is used for adding web history to arrays
    ls.pushToArray = function( key, value, data ){

        if( this.hasData( key ) ){
            var _LS = this.get( key );

            if( _LS.hasOwnProperty( value ) &&  _LS[ value ] instanceof Array ){

                try{

                    _LS[ value ].push( data );

                    this.set( key, _LS );

                    return _LS;

                }catch (e) {

                    return false;
                }


            }
        }


    };

    //get a specific value from localstorage
    //returns false if no value is found
    ls.getValFromStorage = function( key, needle ){
        var hasData = this.hasData( key );

        if( hasData ){

            var _obj = this.get( key );

            if( _obj.hasOwnProperty( needle ) && typeof Object.keys(needle) !== 'undefined' && Object.keys(needle).length > 0 ){

                return _obj[ needle ];

            }else{

                return false;
            }


        }else{

            return hasData;
        }

    };

    ls.deleteFromStorage = function( key, needle ){

        var hasData = this.get( key );

        if( hasData ){

            var _obj = this.get( key );

            if( _obj.hasOwnProperty( needle ) && typeof Object.keys(needle) !== 'undefined' && Object.keys(needle).length > 0 ){

                delete _obj[ needle ];

            }else{

                return false;
            }


        }else{

            return hasData;
        }

    };



    ls.encrypted__set = function( key, value ){

        let data = value;

        if( _model.empty( value ) ){
            return false;
        }

        if( typeof value === 'object' ){

            data = JSON.stringify( data );
        }

        this.set( key, sjcl.encrypt( ITBL.BOBA, data ) );

    };

    ls.decrypt__get = function( key ){

        const returningUser = localStorage.getItem("returningUserStore");
        if (returningUser) {
            let field = key.split("/");
            if (field.length) {
                field = field[field.length - 1];

                const user = JSON.parse(returningUser);
                return user[field];
            }
        }

        var data = this.get( key );

      let value = false;

        if( data && typeof data === 'string'){

            try{

                return JSON.parse( sjcl.decrypt( ITBL.BOBA, data ) );

            }catch (e) {

                return sjcl.decrypt( ITBL.BOBA, data );

            }
        }

      // If value is not an array avoid reading it as an array
      if (key !== 'iterable/encrypted/Marketing_Channels__c' && typeof value === 'string') {
        value = (value || '').split(';').pop().trim();
      }

        return value;

    };

    return ls;
}());
